import { NetworkService } from './network-service';

const API_BASE_URL = process.env.REACT_APP_API_EXECUTION_ADDRESS;

export default class ClipService {
    static async createClipAsync(formData, queryParams) {
        return await NetworkService.postMultiPartAsync(`${API_BASE_URL}/clip`, formData, queryParams);
    }

    static async deleteClipAsync(id) {
        return await NetworkService.deleteAsync(`${API_BASE_URL}/clip/${id}`);
    }

    static async downloadClipAsync(id) {
        return await NetworkService.getBlobAsync(`${API_BASE_URL}/clip/${id}/download`);
    }

    static async analyzeClipAsync(id) {
        return await NetworkService.postAsync(`${API_BASE_URL}/clip/${id}/analyze`, {});
    }

    static async searchClipsAsync(projectId, q) {
        const url = `${API_BASE_URL}/clip/search?projectId=${encodeURIComponent(projectId)}&q=${encodeURIComponent(q || '')}`;
        return await NetworkService.getAsync(url);
    }
}
